import React from 'react';

const iconClass = 'w-6 h-6';

/** Plan card icons — matched to legacy static pricing design by tier index. */
const PLAN_ICONS_BY_INDEX = [
  (
    <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
      />
    </svg>
  ),
  (
    <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M13 10V3L4 14h7v7l9-11h-7z"
      />
    </svg>
  ),
  (
    <svg className={iconClass} fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
      />
    </svg>
  ),
];

/**
 * @param {number} index - Zero-based position in sorted price list
 * @returns {React.ReactNode}
 */
export function getPricingPlanIcon(index) {
  if (index < 0) return PLAN_ICONS_BY_INDEX[0];
  return PLAN_ICONS_BY_INDEX[index % PLAN_ICONS_BY_INDEX.length];
}

/**
 * @param {Object} apiPlan - Row from GET /api/public/plans
 * @param {number} index
 */
export function mapApiPlanToPricingCard(apiPlan, index) {
  const monthlyPrice = Number(apiPlan.monthlyPrice) || 0;
  const annualPrice = Number(apiPlan.annualPrice) || 0;
  const annualDiscount = apiPlan.annualDiscount
    ? {
        enabled: Boolean(apiPlan.annualDiscount.enabled),
        savingsPercent: Number(apiPlan.annualDiscount.savingsPercent) || 0,
        discountType: apiPlan.annualDiscount.discountType || null,
        discountValue:
          apiPlan.annualDiscount.discountValue != null
            ? Number(apiPlan.annualDiscount.discountValue)
            : null,
        discountLabel: apiPlan.annualDiscount.discountLabel || null,
      }
    : {
        enabled: annualPrice > 0 && annualPrice < monthlyPrice,
        savingsPercent:
          monthlyPrice > 0 && annualPrice < monthlyPrice
            ? Math.round(((monthlyPrice - annualPrice) / monthlyPrice) * 100)
            : 0,
        discountType: 'percentage',
        discountValue: null,
        discountLabel: null,
      };

  return {
    id: apiPlan.id,
    name: apiPlan.name,
    description: apiPlan.description,
    monthlyPrice,
    annualPrice,
    annualTotal: Number(apiPlan.annualTotal) || 0,
    annualListPrice: Number(apiPlan.annualListPrice) || 0,
    annualDiscount,
    features: Array.isArray(apiPlan.features) ? apiPlan.features : [],
    popular: Boolean(apiPlan.popular),
    icon: getPricingPlanIcon(index),
  };
}
